<template>
  <div class="SplashScreen splach-container loading-colors">
    <div class="loading d-flex column p-absolute justify-center items-center">
      <img src="@/assets/images/logo-mark.svg" alt="zarinPal" />
      <div class="proccessBar bg-cont-dim p-relative">
        <div class="indeterminate p-absolute bar h-100 bg-loading-color"></div>
      </div>
    </div>
    <div class="bottom-logo d-flex column p-absolute justify-center items-center">
      <img src="@/assets/images/logo-type.svg" alt="zarinPal" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import './index.scss';
</style>
